import React from 'react'

export const Cultivate = () => {
  return (
    <>
    <section className="CultivateSection">
        <div className='container'>
            <div className='row'>
                <div className='col-lg-6 oursolarwork'>
                <h2>Cultivated & Inspired </h2>
                <p>
                At VTV Energy, we redefine 'ordinary' by infusing it with innovation and dedication. Our relentless pursuit of excellence sets us apart in the solar energy
                </p>
                {/* <button className='btnwork'>Learn More</button> */}
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
